import _regeneratorRuntime from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/metagest/public_html/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __awaiter } from 'tslib';
import { useState, useEffect } from 'react';

function getGeoLocation(options) {
  return new Promise(function (resolve, reject) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (res) {
        var coords = res.coords;
        var latitude = coords.latitude,
            longitude = coords.longitude;
        resolve({
          lat: latitude,
          lng: longitude,
          isError: false,
          message: ""
        });
      }, function (err) {
        reject({
          message: err.message,
          isError: true
        });
      }, options);
    } else {
      reject({
        isError: true,
        message: "Geolocation is not supported for this Browser/OS."
      });
    }
  });
} // interface IUseGeoLocationHook {
//   when?: boolean;
// }
// const defaultHookOptions = {
//   when: true
// };


var defaultGeoLocationOptions = {
  enableHighAccuracy: false,
  timeout: Infinity,
  maximumAge: 0,
  when: true
};
/**
 * useGeolocation
 * Gets the geolocation data as a hook
 * @param geoLocationOptions Geolocation options
 */

function useGeolocation() {
  var geoLocationOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGeoLocationOptions;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      geoObj = _useState2[0],
      setGeoObj = _useState2[1];

  var when = geoLocationOptions.when,
      enableHighAccuracy = geoLocationOptions.enableHighAccuracy,
      timeout = geoLocationOptions.timeout,
      maximumAge = geoLocationOptions.maximumAge;
  useEffect(function () {
    function getGeoCode() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getGeoLocation({
                  when: when,
                  enableHighAccuracy: enableHighAccuracy,
                  timeout: timeout,
                  maximumAge: maximumAge
                });

              case 3:
                value = _context.sent;
                setGeoObj(value);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                setGeoObj(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
    }

    if (when) {
      getGeoCode();
    }
  }, [when, enableHighAccuracy, timeout, maximumAge]);
  return geoObj;
}

export default useGeolocation;